import { render, staticRenderFns } from "./creditExtensionAttachment.vue?vue&type=template&id=1770327e&scoped=true"
import script from "./creditExtensionAttachment.vue?vue&type=script&lang=js"
export * from "./creditExtensionAttachment.vue?vue&type=script&lang=js"
import style0 from "./creditExtensionAttachment.vue?vue&type=style&index=0&id=1770327e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770327e",
  null
  
)

export default component.exports